const Footer = () => {
  return (
    <footer>
      <div className="container footer-inner">
        <span>&copy; 2025 Nexus Unified Solution &amp; Consultancy Services (Private) Limited. All rights reserved.</span>
        <span>Islamabad, Pakistan</span>
      </div>
    </footer>
  );
};

export default Footer;
